export default "__VITE_ASSET__fh397hkj__"